import { collection, query, where } from 'firebase/firestore'
import type { Query } from 'firebase/firestore'
import { db } from '../lib/firebase'
import { useFirestoreCollection } from './useFirestore'
import type { GroupEvent } from '../types'

export function useGroupsEvents(groupIds: string[]): { data: GroupEvent[]; loading: boolean } {
  const ref =
    groupIds.length > 0
      ? (query(collection(db, 'groupEvents'), where('groupId', 'in', groupIds)) as Query<GroupEvent>)
      : null
  const { data, loading } = useFirestoreCollection<GroupEvent>(ref)
  return { data, loading }
}
